/**
 * Tables transferred during P2P / QR transfer.
 *
 * ⚠️ CC-33: excludes audit / server-materialized version tables (`recipe_version`).
 */
export const P2P_TRANSFER_TABLES = [
  "aisle",
  "recipe",
  "recipe_ingredient",
  "meal_plan_entry",
  "pantry_item",
  "shopping_list",
  "shopping_item",
  "attachment",
] as const;

export type P2pTransferTable = (typeof P2P_TRANSFER_TABLES)[number];
